// Assets
import {
  IconFileText,
  IconFileSpreadsheet,
  IconPhoto as IconFileImage,
  IconPresentation as IconFilePresentation,
  IconFiles as IconFilePdf,
  IconFileZip as IconFileArchive,
  IconVideo as IconFileVideo,
  IconFileUnknown,
  IconProps,
} from '@tabler/icons-react';
import { palette } from '@ui-kit/colors';
import { ResourceMimeType } from '@app-types/blackroom-app/resourceMimeType';
import { ForwardRefExoticComponent, RefAttributes } from 'react';

export const resourceFileImageMimeTypes = [
  ResourceMimeType.jpeg,
  ResourceMimeType.png,
  ResourceMimeType.ico,
  ResourceMimeType.svg,
  ResourceMimeType.gif,
  ResourceMimeType.webp,
  ResourceMimeType.bmp,
];

export const resourceFileDocumentMimeTypes = [
  ResourceMimeType.doc,
  ResourceMimeType.docx,
  ResourceMimeType.docm,
  ResourceMimeType.dotx,
  ResourceMimeType.dotm,
  ResourceMimeType.odt,
  ResourceMimeType.md,
  ResourceMimeType.plain,
  ResourceMimeType.eml,
];

export const resourceFilePdfMimeTypes = [ResourceMimeType.pdf];

export const resourceFileSpreadsheetMimeTypes = [
  ResourceMimeType.xls,
  ResourceMimeType.xlsx,
  ResourceMimeType.xlsm,
  ResourceMimeType.xlsb,
  ResourceMimeType.xltx,
  ResourceMimeType.xltm,
  ResourceMimeType.csv,
  ResourceMimeType.ods,
];

export const resourceFilePresentationMimeTypes = [
  ResourceMimeType.ppt,
  ResourceMimeType.pptx,
  ResourceMimeType.pptm,
  ResourceMimeType.potx,
  ResourceMimeType.ppsx,
  ResourceMimeType.odp,
];

export const resourceFileArchiveMimeTypes = [
  ResourceMimeType.zip,
  ResourceMimeType.rar,
  ResourceMimeType.bz2,
  ResourceMimeType.bz,
  ResourceMimeType.arc,
];

export const resourceFileVideoMimeTypes = [
  ResourceMimeType.mp4,
  ResourceMimeType.mov,
  ResourceMimeType.avi,
  ResourceMimeType.webm,
  ResourceMimeType.mpeg,
  ResourceMimeType.m4v,
  ResourceMimeType.ogg,
];

function getFileIcon(mimeType: ResourceMimeType): {
  Component: ForwardRefExoticComponent<
    IconProps & RefAttributes<SVGSVGElement>
  >;
  color: string;
} {
  if (resourceFileImageMimeTypes.includes(mimeType)) {
    return {
      Component: IconFileImage,
      color: palette.blackroomGray,
    };
  }
  if (resourceFileDocumentMimeTypes.includes(mimeType)) {
    return {
      Component: IconFileText,
      color: palette.blackroomBlue,
    };
  }
  if (resourceFilePdfMimeTypes.includes(mimeType)) {
    return {
      Component: IconFilePdf,
      color: palette.blackroomRed,
    };
  }
  if (resourceFileSpreadsheetMimeTypes.includes(mimeType)) {
    return {
      Component: IconFileSpreadsheet,
      color: palette.blackroomGreen,
    };
  }
  if (resourceFilePresentationMimeTypes.includes(mimeType)) {
    return {
      Component: IconFilePresentation,
      color: palette.blackroomOrange,
    };
  }

  if (resourceFileArchiveMimeTypes.includes(mimeType)) {
    return {
      Component: IconFileArchive,
      color: palette.blackroomOrange,
    };
  }

  if (resourceFileVideoMimeTypes.includes(mimeType)) {
    return {
      Component: IconFileVideo,
      color: palette.blackroomOrange,
    };
  }

  return { Component: IconFileUnknown, color: palette.blackroomGray };
}

export default getFileIcon;
